module.exports = __webpack_public_path__ + "static/img/banner1-m.cc9f963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner1-m.png
// module id = Hcc/
// module chunks = 0